import React from 'react'
import Icon from './Icon'

class EmailShare extends React.Component {
  render () {
    return (
      <Icon {...this.props}>
        {/* <svg version='1.0' xmlns='http://www.w3.org/2000/svg'
          width='24px' height='24px' viewBox='0 0 186 186'
          preserveAspectRatio='xMidYMid meet'>
          <g transform='translate(0.000000,200.000000) scale(0.100000,-0.100000)'
            fill='#858485' stroke='none'>
            <path d='M196 1695 c-21 -7 -54 -28 -72 -46 -66 -64 -64 -49 -64 -561 0 -518
              -1 -510 73 -575 58 -51 98 -54 532 -51 l390 3 7 53 c11 76 41 127 124 212 l72
              75 -120 112 -120 113 -60 -50 c-82 -69 -89 -69 -170 2 l-58 50 -197 -187
              c-109 -103 -208 -192 -220 -198 -18 -8 -27 -6 -43 8 -40 37 -29 53 180 249
              110 103 200 190 200 191 0 2 -57 52 -127 111 -232 196 -273 234 -273 258 0 28
              18 46 46 46 15 0 119 -81 300 -235 241 -204 280 -233 293 -221 378 323 543
              456 566 456 27 0 52 -37 42 -63 -4 -10 -312 -277 -396 -344 -6 -5 78 -90 162
              -165 l68 -61 132 130 c100 98 144 134 180 148 l47 18 0 186 c0 158 -3 192 -19
              226 -23 51 -79 101 -128 114 -25 7 -259 11 -673 11 -514 -1 -642 -4 -674 -15z' />
            <path d='M1698 1066 c-43 -16 -93 -54 -168 -130 l-54 -56 30 0 c17 0 46 -5 63
              -11 32 -11 34 -10 91 46 50 49 63 57 96 57 47 0 84 -37 84 -84 0 -26 -17 -48
              -104 -137 -93 -94 -108 -105 -140 -105 -19 0 -43 8 -54 17 -27 24 -44 21 -78
              -14 l-29 -31 33 -27 c30 -26 91 -51 123 -51 58 0 98 26 208 134 62 61 120 125
              127 143 18 41 18 104 0 146 -17 43 -76 93 -123 106 -48 14 -59 13 -105 -3z' />
            <path d='M1433 810 c-51 -22 -205 -168 -245 -229 -90 -142 38 -320 202 -279
              35 9 63 29 133 97 l89 86 -58 13 -58 13 -57 -57 c-49 -48 -62 -56 -95 -56 -47
              0 -84 37 -84 85 0 26 16 47 108 139 117 117 136 126 185 88 34 -27 48 -25 83
              11 l29 31 -33 27 c-34 29 -92 51 -133 51 -13 0 -43 -9 -66 -20z' />
          </g>
        </svg>
        <svg version='1.0' xmlns='http://www.w3.org/2000/svg'
          width='24px' height='24px' viewBox='0 0 186 186'
          preserveAspectRatio='xMidYMid meet'>
          <g transform='translate(0.000000,200.000000) scale(0.100000,-0.100000)'
            fill='#858485' stroke='none'>
            <path d='M196 1695 c-21 -7 -54 -28 -72 -46 -66 -64 -64 -49 -64 -561 0 -518
            -1 -510 73 -575 58 -51 98 -54 532 -51 l390 3 5 48 6 47 -403 0 c-433 0 -452
            2 -487 51 -14 21 -16 74 -16 476 l0 453 29 32 29 33 657 0 657 0 29 -33 29
            -32 0 -204 0 -204 50 21 50 21 0 185 c0 158 -3 192 -19 226 -23 51 -79 101
            -128 114 -25 7 -259 11 -673 11 -514 -1 -642 -4 -674 -15z' />
            <path d='M262 1498 c-13 -13 -16 -47 -4 -63 4 -6 94 -84 200 -173 105 -90 192
            -164 192 -166 0 -2 -90 -89 -200 -192 -209 -196 -220 -212 -180 -249 16 -14
            25 -16 43 -8 12 6 111 95 220 198 l197 187 58 -50 c81 -71 88 -71 170 -2 l60
            50 116 -110 c64 -60 120 -110 124 -110 4 0 22 14 40 30 l33 30 -118 114 c-65
            63 -116 116 -113 118 3 3 92 78 198 168 107 89 196 169 199 177 3 8 1 25 -5
            39 -25 53 -50 38 -342 -211 -228 -194 -277 -232 -289 -222 -9 7 -134 112 -279
            235 -260 220 -291 239 -320 210z' />
            <path d='M1690 1067 c-21 -7 -70 -45 -123 -96 l-88 -85 63 -13 63 -13 55 54
            c30 29 63 56 73 60 24 8 83 -18 96 -42 26 -49 15 -71 -90 -178 -116 -117 -137
            -127 -198 -92 l-40 23 -30 -29 c-17 -17 -31 -33 -31 -38 0 -16 82 -67 119 -73
            78 -13 116 8 238 128 121 119 143 152 143 216 0 57 -20 100 -63 138 -56 49
            -117 62 -187 40z' />
            <path d='M1424 809 c-59 -28 -238 -214 -254 -263 -40 -124 46 -246 173 -246
            69 0 101 19 196 114 l83 83 -64 6 -63 6 -56 -56 c-49 -47 -62 -55 -95 -55 -47
            0 -84 37 -84 85 0 26 16 47 108 139 117 117 136 126 185 88 34 -27 48 -25 82
            10 28 29 28 30 9 51 -27 31 -92 59 -139 59 -22 0 -59 -9 -81 -21z' />
          </g>
  </svg> */}
        <svg
          width='24px'
          height='24px'
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
        >
          <title />
          <path
            d='M18,21H6a3,3,0,0,1-3-3V6A3,3,0,0,1,6,3h4a1,1,0,0,1,0,2H6A1,1,0,0,0,5,6V18a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V14a1,1,0,0,1,2,0v4A3,3,0,0,1,18,21Z'
            fill='#858485'
          />
          <path
            d='M21,4.05v5a1,1,0,0,1-.62.92.84.84,0,0,1-.38.08,1,1,0,0,1-.71-.29L17.45,8l-4.79,4.79a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42L16,6.55,14.24,4.76A1,1,0,0,1,14,3.67,1,1,0,0,1,15,3.05h5a.73.73,0,0,1,.25,0,.37.37,0,0,1,.14,0,.94.94,0,0,1,.53.53.37.37,0,0,1,0,.14A.73.73,0,0,1,21,4.05Z'
            fill='#858485'
          />
        </svg>
      </Icon>
    )
  }
}

export default EmailShare
